import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo/logo.png';
import _imports_1 from '@/assets/images/icons/tip-while.svg';
import _imports_2 from '@/assets/images/icons/new.svg';
import _imports_3 from '@/assets/images/icons/offline.svg';
import _imports_4 from '@/assets/images/icons/fil.svg';
import _imports_5 from '@/assets/images/icons/eth.svg';
import _imports_6 from '@/assets/images/filecoin-logo.svg';
import _imports_7 from '@/assets/images/stfil-logo.svg';
import _imports_8 from '@/assets/images/wstfil-logo.png';
import _imports_9 from '@/assets/images/icons/okx.svg';
import _imports_10 from '@/assets/images/icons/recommend.svg';
import _imports_11 from '@/assets/images/icons/recommend_en.svg';
import _imports_12 from '@/assets/images/icons/metamask.svg';
import _imports_13 from '@/assets/images/icons/metamaskflask.png';
import _imports_14 from '@/assets/images/icons/ledger.png';
import _imports_15 from '@/assets/images/icons/foxWallet.svg';
import _imports_16 from '@/assets/images/logo/TokenPocket.svg';
import _imports_17 from '@/assets/images/icons/walletconnect.svg';
import _imports_18 from '@/assets/images/icons/switch_wallet.png';
import _imports_19 from '@/assets/images/icons/ch.png';
const _withScopeId = n => (_pushScopeId("data-v-5ef8cb14"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-nav position-relative"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "navbar navbar-expand-lg navbar-light px-0 d-flex justify-content-between align-items-center flex-nowrap"
};
const _hoisted_4 = {
  class: "d-flex align-items-center position-relative"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand p-0",
  href: "#"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid logo-prompt",
  src: _imports_0
})])], -1));
const _hoisted_6 = {
  key: 0,
  class: "hyperspace-net-content"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fw-bold fs-12 hyperspace-net text-nowrap"
}, [/*#__PURE__*/_createTextVNode(" Calibration Net "), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "20px",
    "cursor": "pointer",
    "padding-bottom": "1px"
  },
  src: _imports_1,
  alt: ""
})])], -1));
const _hoisted_8 = {
  class: "d-flex flex-column justify-content-center align-items-start p-2"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fw-bold"
}, " Calibration Net ", -1));
const _hoisted_10 = {
  class: "mt-2"
};
const _hoisted_11 = {
  class: "mt-2"
};
const _hoisted_12 = {
  style: {
    "color": "#555555"
  }
};
const _hoisted_13 = {
  class: "d-flex align-items-center"
};
const _hoisted_14 = {
  style: {
    "padding-left": "5px"
  }
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  key: 0,
  src: _imports_2,
  style: {
    "width": "24px",
    "margin-left": "2px",
    "transform": "translateY(-2px)"
  },
  alt: ""
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nav-toggle-icon",
  viewBox: "0 0 100 100",
  width: "40"
}, [/*#__PURE__*/_createElementVNode("path", {
  class: "line top",
  d: "m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20"
}), /*#__PURE__*/_createElementVNode("path", {
  class: "line middle",
  d: "m 70,50 h -40"
}), /*#__PURE__*/_createElementVNode("path", {
  class: "line bottom",
  d: "m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20"
})], -1));
const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = {
  class: "collapse navbar-collapse",
  id: "navlinks"
};
const _hoisted_20 = {
  class: "navbar-nav ml-xl-auto mr-sm-3 mr-lg-3 d-flex align-items-center"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  key: 0,
  src: _imports_2,
  style: {
    "width": "24px",
    "position": "absolute",
    "margin-left": "2px",
    "top": "-4px"
  },
  alt: ""
};
const _hoisted_23 = {
  key: 1,
  class: "cursor-pointer position-relative",
  style: {
    "margin-bottom": "3px"
  }
};
const _hoisted_24 = {
  class: "el-dropdown-link"
};
const _hoisted_25 = {
  class: "fw-bold fs-sm-14 fs-sm-12 mr-1"
};
const _hoisted_26 = {
  class: "wallet-head-btn d-flex align-items-center justify-content-between"
};
const _hoisted_27 = {
  class: "d-md-none d-block"
};
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "fw-bold fsi-14 d-md-flex d-none align-items-center justify-content-between"
};
const _hoisted_30 = {
  class: "mr-2 position-relative",
  style: {
    "margin-bottom": "1px",
    "margin-left": "12px"
  }
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  key: 0,
  class: "flex-center",
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "right": "0",
    "bottom": "0"
  }
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {
    "width": "20px",
    "height": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_34 = [_hoisted_33];
const _hoisted_35 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_36 = {
  key: 1,
  class: "mr-2"
};
const _hoisted_37 = {
  class: "flex-center",
  style: {
    "margin-right": "12px"
  }
};
const _hoisted_38 = {
  style: {
    "padding": "20px 20px",
    "color": "#000 !important",
    "position": "relative"
  }
};
const _hoisted_39 = {
  class: "d-flex align-items-center"
};
const _hoisted_40 = {
  class: "fw-bold fsi-20"
};
const _hoisted_41 = {
  class: "d-flex align-items-start mt-3",
  style: {
    "color": "rgb(23, 52, 79)",
    "font-weight": "600"
  }
};
const _hoisted_42 = {
  class: "position-relative mr-2"
};
const _hoisted_43 = ["src"];
const _hoisted_44 = {
  style: {
    "flex": "1 1 0%"
  }
};
const _hoisted_45 = {
  key: 0,
  class: "d-flex justify-content-between"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_47 = {
  key: 1,
  class: "cursor-pointer Copy",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_48 = {
  key: 1,
  class: "d-flex justify-content-between"
};
const _hoisted_49 = {
  class: "flex-center"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "24px",
    "color": "#787878",
    "text-align": "center"
  }
}, "#", -1));
const _hoisted_51 = {
  key: 2,
  class: "d-flex justify-content-between"
};
const _hoisted_52 = {
  key: 0
};
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_54 = {
  key: 1,
  class: "d-sm-block d-none"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_56 = {
  class: "fsi-14"
};
const _hoisted_57 = {
  key: 2,
  class: "d-block d-sm-none"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_59 = {
  class: "fsi-14"
};
const _hoisted_60 = {
  key: 4,
  class: "cursor-pointer fs-12",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_61 = {
  key: 3,
  class: "d-flex justify-content-between mt-1"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {
    "width": "18px"
  }
}, null, -1));
const _hoisted_63 = {
  key: 1,
  class: "cursor-pointer fs-12",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_64 = {
  class: "row",
  style: {
    "margin-top": "2rem",
    "margin-bottom": "1rem"
  }
};
const _hoisted_65 = {
  class: "col-12 fsi-12",
  style: {
    "font-size": "12px"
  }
};
const _hoisted_66 = {
  class: "d-flex justify-content-between"
};
const _hoisted_67 = {
  class: "d-flex align-items-center"
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-2"
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "32px",
    "transform": "translateY(-4px)"
  },
  src: _imports_6,
  alt: ""
})], -1));
const _hoisted_69 = {
  class: "d-flex flex-column"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "2px",
    "color": "#000",
    "font-weight": "600"
  }
}, "FIL")], -1));
const _hoisted_71 = {
  class: "mt-1"
};
const _hoisted_72 = {
  class: "ml-1"
};
const _hoisted_73 = {
  style: {
    "color": "rgb(23, 52, 79)",
    "font-size": "13px"
  }
};
const _hoisted_74 = {
  class: "ml-1"
};
const _hoisted_75 = {
  style: {
    "color": "#000"
  }
};
const _hoisted_76 = {
  class: "col-12",
  style: {
    "margin-top": "1.5rem",
    "font-size": "12px"
  }
};
const _hoisted_77 = {
  class: "d-flex"
};
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-2"
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "32px",
    "transform": "translateY(-1px)"
  },
  src: _imports_7,
  alt: ""
})], -1));
const _hoisted_79 = {
  class: "d-flex flex-column w-100"
};
const _hoisted_80 = {
  class: "d-flex justify-content-between align-items-center",
  style: {
    "flex": "1"
  }
};
const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "2px",
    "color": "#000",
    "font-weight": "600"
  }
}, "stFIL")], -1));
const _hoisted_82 = {
  class: "ml-1"
};
const _hoisted_83 = {
  style: {
    "color": "#000"
  }
};
const _hoisted_84 = {
  class: "mt-1"
};
const _hoisted_85 = {
  class: "ml-1"
};
const _hoisted_86 = {
  style: {
    "color": "rgb(23, 52, 79)",
    "font-size": "13px"
  }
};
const _hoisted_87 = {
  class: "col-12",
  style: {
    "margin-top": "1.5rem",
    "font-size": "12px"
  }
};
const _hoisted_88 = {
  class: "d-flex"
};
const _hoisted_89 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-2"
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "32px",
    "transform": "translateY(-1px)"
  },
  src: _imports_8,
  alt: ""
})], -1));
const _hoisted_90 = {
  class: "d-flex flex-column w-100"
};
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-between align-items-center",
  style: {
    "flex": "1"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "2px",
    "color": "#000",
    "font-weight": "600"
  }
}, "wstFIL")]), /*#__PURE__*/_createElementVNode("div")], -1));
const _hoisted_92 = {
  class: "mt-1"
};
const _hoisted_93 = {
  class: "ml-1"
};
const _hoisted_94 = {
  style: {
    "color": "rgb(23, 52, 79)",
    "font-size": "13px"
  }
};
const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line",
  style: {
    "margin-top": "1rem",
    "margin-bottom": "1rem"
  }
}, null, -1));
const _hoisted_96 = {
  class: "d-flex justify-content-between"
};
const _hoisted_97 = {
  class: "d-flex align-items-center"
};
const _hoisted_98 = {
  class: "d-flex flex-column"
};
const _hoisted_99 = {
  style: {
    "margin-left": "2px",
    "color": "#000",
    "font-weight": "600"
  }
};
const _hoisted_100 = {
  class: "ml-1"
};
const _hoisted_101 = {
  style: {
    "color": "#000",
    "font-size": "12px"
  }
};
const _hoisted_102 = {
  class: "col-12 flex-center mt-3"
};
const _hoisted_103 = {
  class: "send-icon-btn"
};
const _hoisted_104 = {
  class: "fs-12 mt-1"
};
const _hoisted_105 = {
  class: "send-icon-btn"
};
const _hoisted_106 = {
  class: "fs-12 mt-1"
};
const _hoisted_107 = {
  key: 0,
  class: "mt-4 language"
};
const _hoisted_108 = {
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_109 = {
  class: "fsi-16 fw-medium"
};
const _hoisted_110 = {
  style: {
    "width": "30%",
    "min-width": "120px"
  },
  class: "language-select"
};
const _hoisted_111 = {
  class: "mb-1 fsi-14"
};
const _hoisted_112 = {
  key: 0,
  class: "option-input-tip-err"
};
const _hoisted_113 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mt-3 mb-3"
}, null, -1));
const _hoisted_114 = {
  class: "cursor-pointer d-flex align-items-center disconnect-wallet"
};
const _hoisted_115 = {
  class: "d-flex justify-content-center align-items-center"
};
const _hoisted_116 = {
  class: "fw-bold fsi-20"
};
const _hoisted_117 = {
  key: 0,
  class: "mt-2 mb-3"
};
const _hoisted_118 = {
  class: "flex-center mt-2"
};
const _hoisted_119 = {
  class: "mt-2 mb-4",
  style: {},
  ref: "qrAddress"
};
const _hoisted_120 = {
  class: "flex-center flex-column"
};
const _hoisted_121 = {
  class: "mt-2"
};
const _hoisted_122 = {
  key: 0,
  class: "show-address-address flex-center"
};
const _hoisted_123 = {
  class: "mr-2"
};
const _hoisted_124 = {
  key: 1,
  class: "cursor-pointer fs-12",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_125 = {
  key: 1,
  class: "show-address-address flex-center"
};
const _hoisted_126 = {
  class: "mr-2"
};
const _hoisted_127 = {
  key: 1,
  class: "cursor-pointer fs-12",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_128 = {
  key: 2,
  class: "show-address-address flex-center"
};
const _hoisted_129 = {
  class: "mr-2"
};
const _hoisted_130 = {
  key: 1,
  class: "cursor-pointer Copy",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_131 = {
  class: "d-flex justify-content-center"
};
const _hoisted_132 = {
  class: "fw-extra-bold fsi-24 mt-4"
};
const _hoisted_133 = {
  class: "row pb-4"
};
const _hoisted_134 = {
  class: "col-12"
};
const _hoisted_135 = {
  key: 0,
  class: "flex-center mb-2",
  style: {
    "transform": "translateY(-20px)"
  }
};
const _hoisted_136 = {
  style: {
    "width": "85%",
    "color": "rgba(75, 17, 19, 0.8)",
    "border-radius": "4px",
    "border-left": "solid 4px rgb(225, 50, 56)",
    "background-color": "rgb(255, 235, 236)",
    "padding": "5px 10px"
  }
};
const _hoisted_137 = {
  class: "d-flex justify-content-center connectWalletModel"
};
const _hoisted_138 = {
  class: "w-100 d-flex align-items-center wallet-connect position-relative",
  style: {
    "border": "1px solid #e2e2e2",
    "padding": "14px 16px",
    "border-radius": "10px",
    "overflow": "hidden"
  }
};
const _hoisted_139 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_140 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  style: {
    "height": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_141 = [_hoisted_140];
const _hoisted_142 = {
  key: 1,
  class: "mr-2"
};
const _hoisted_143 = {
  class: "fsi-14 text-center d-flex align-items-center justify-content-center",
  style: {
    "flex": "1 1 0%"
  }
};
const _hoisted_144 = {
  class: "mr-2"
};
const _hoisted_145 = {
  style: {
    "position": "absolute",
    "right": "0",
    "top": "0"
  }
};
const _hoisted_146 = {
  key: 0
};
const _hoisted_147 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  style: {
    "height": "30px"
  },
  alt: ""
}, null, -1));
const _hoisted_148 = [_hoisted_147];
const _hoisted_149 = {
  key: 1
};
const _hoisted_150 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  style: {
    "height": "30px"
  },
  alt: ""
}, null, -1));
const _hoisted_151 = [_hoisted_150];
const _hoisted_152 = {
  class: "w-100 d-flex align-items-center wallet-connect",
  style: {
    "border": "1px solid #e2e2e2",
    "padding": "0 16px",
    "border-radius": "10px",
    "height": "60px"
  }
};
const _hoisted_153 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_154 = {
  key: 1,
  class: "mr-2"
};
const _hoisted_155 = {
  class: "fsi-14 text-center d-flex align-items-center justify-content-center",
  style: {
    "flex": "1 1 0%"
  }
};
const _hoisted_156 = {
  class: "mr-2"
};
const _hoisted_157 = {
  class: "w-100 d-flex align-items-center wallet-connect",
  style: {
    "border": "1px solid #e2e2e2",
    "padding": "16px",
    "border-radius": "10px"
  }
};
const _hoisted_158 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_159 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  style: {
    "height": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_160 = [_hoisted_159];
const _hoisted_161 = {
  key: 1,
  class: "mr-2"
};
const _hoisted_162 = {
  class: "fsi-14 text-center d-flex align-items-center justify-content-center",
  style: {
    "flex": "1 1 0%"
  }
};
const _hoisted_163 = {
  class: "mr-2"
};
const _hoisted_164 = {
  class: "w-100 d-flex align-items-center wallet-connect",
  style: {
    "border": "1px solid #e2e2e2",
    "padding": "16px",
    "border-radius": "10px"
  }
};
const _hoisted_165 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_166 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  style: {
    "height": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_167 = [_hoisted_166];
const _hoisted_168 = {
  key: 1,
  class: "mr-2"
};
const _hoisted_169 = {
  class: "fsi-14 text-center d-flex align-items-center justify-content-center",
  style: {
    "flex": "1 1 0%"
  }
};
const _hoisted_170 = {
  class: "mr-2"
};
const _hoisted_171 = {
  class: "w-100 d-flex align-items-center wallet-connect",
  style: {
    "border": "1px solid #e2e2e2",
    "padding": "16px",
    "border-radius": "10px"
  }
};
const _hoisted_172 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_173 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  style: {
    "height": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_174 = [_hoisted_173];
const _hoisted_175 = {
  key: 1,
  class: "mr-2"
};
const _hoisted_176 = {
  class: "fsi-14 text-center d-flex align-items-center justify-content-center",
  style: {
    "flex": "1 1 0%"
  }
};
const _hoisted_177 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-2"
}, [/*#__PURE__*/_createTextVNode(" Ledger"), /*#__PURE__*/_createElementVNode("span", {
  class: "fs-12"
}, "(Filecoin)")], -1));
const _hoisted_178 = {
  class: "w-100 d-flex align-items-center wallet-connect",
  style: {
    "border": "1px solid #e2e2e2",
    "padding": "16px",
    "border-radius": "10px"
  }
};
const _hoisted_179 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_180 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  style: {
    "height": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_181 = [_hoisted_180];
const _hoisted_182 = {
  key: 1,
  class: "mr-2"
};
const _hoisted_183 = {
  class: "fsi-14 text-center d-flex align-items-center justify-content-center",
  style: {
    "flex": "1 1 0%"
  }
};
const _hoisted_184 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-2"
}, " FoxWallet ", -1));
const _hoisted_185 = {
  class: "w-100 d-flex align-items-center wallet-connect",
  style: {
    "border": "1px solid #e2e2e2",
    "padding": "16px",
    "border-radius": "10px"
  }
};
const _hoisted_186 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_187 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  style: {
    "height": "20px"
  },
  alt: ""
}, null, -1));
const _hoisted_188 = [_hoisted_187];
const _hoisted_189 = {
  key: 1,
  class: "mr-2"
};
const _hoisted_190 = {
  class: "fsi-16 text-center d-flex align-items-center justify-content-center",
  style: {
    "flex": "1 1 0%"
  }
};
const _hoisted_191 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-2"
}, " TokenPocket ", -1));
const _hoisted_192 = {
  class: "w-100 d-flex align-items-center wallet-connect",
  style: {
    "border": "1px solid #e2e2e2",
    "padding": "16px",
    "border-radius": "10px"
  }
};
const _hoisted_193 = {
  key: 0,
  class: "mr-2"
};
const _hoisted_194 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  style: {
    "height": "15px"
  },
  alt: ""
}, null, -1));
const _hoisted_195 = [_hoisted_194];
const _hoisted_196 = {
  key: 1,
  class: "mr-2"
};
const _hoisted_197 = {
  class: "fsi-14 text-center d-flex align-items-center justify-content-center",
  style: {
    "flex": "1 1 0%"
  }
};
const _hoisted_198 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mr-2"
}, " WalletConnect ", -1));
const _hoisted_199 = {
  class: "row",
  style: {
    "color": "#101B52"
  }
};
const _hoisted_200 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-12"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  style: {
    "width": "60%"
  },
  alt: ""
})])], -1));
const _hoisted_201 = {
  class: "col-12"
};
const _hoisted_202 = {
  class: "fw-bold fsi-18 text-center"
};
const _hoisted_203 = {
  class: "col-12 mt-2"
};
const _hoisted_204 = {
  class: "text-center fw-medium fsi-14"
};
const _hoisted_205 = {
  class: "col-12 mt-4"
};
const _hoisted_206 = {
  key: 0,
  class: "language-tips",
  id: "model-language-tips"
};
const _hoisted_207 = {
  class: "language-tips-content"
};
const _hoisted_208 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "language-tips-content-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  style: {
    "width": "32px",
    "height": "32px"
  },
  alt: ""
})], -1));
const _hoisted_209 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "language-tips-content-text"
}, [/*#__PURE__*/_createTextVNode(" 我们想更改stfil.app的语言为"), /*#__PURE__*/_createElementVNode("span", {
  class: "link-text-ordinary fw-extra-bold ml-1"
}, "简体中文")], -1));
const _hoisted_210 = {
  class: "language-tips-content-btn"
};
const _hoisted_211 = {
  class: "d-flex justify-content-start"
};
const _hoisted_212 = {
  class: "fw-bold fsi-20",
  style: {
    "color": "white"
  }
};
const _hoisted_213 = {
  class: "row"
};
const _hoisted_214 = {
  class: "col-12"
};
const _hoisted_215 = {
  class: "fs-12 d-flex justify-content-between align-items-center",
  style: {
    "height": "24px",
    "margin-bottom": "0.4rem"
  }
};
const _hoisted_216 = {
  class: "flex-center justify-content-end"
};
const _hoisted_217 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "APY:", -1));
const _hoisted_218 = {
  key: 0,
  class: "ml-1 mr-2 fw-bold"
};
const _hoisted_219 = {
  key: 1,
  class: "computerApyResultInput ml-1"
};
const _hoisted_220 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {
    "font-style": "normal"
  }
}, "%", -1));
const _hoisted_221 = {
  class: "computerFilInput"
};
const _hoisted_222 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {
    "font-style": "normal"
  }
}, "FIL", -1));
const _hoisted_223 = {
  class: "d-flex align-items-center mt-2"
};
const _hoisted_224 = {
  class: "mb-2 fs-12 mt-3"
};
const _hoisted_225 = {
  class: "d-flex align-items-center mt-2 justify-content-between computer-fil-day"
};
const _hoisted_226 = ["onClick"];
const _hoisted_227 = {
  class: "mt-4 d-flex justify-content-center"
};
const _hoisted_228 = {
  class: "mt-3"
};
const _hoisted_229 = {
  class: "computer-fil-result-content"
};
const _hoisted_230 = {
  class: "computer-fil-result"
};
const _hoisted_231 = {
  class: "mb-1",
  style: {
    "color": "#6752F0"
  }
};
const _hoisted_232 = {
  class: "d-flex justify-content-between align-items-center mt-1",
  style: {
    "height": "40px"
  }
};
const _hoisted_233 = {
  class: "fw-extra-bold fsi-22"
};
const _hoisted_234 = {
  key: 1,
  class: "computerFilResultInput"
};
const _hoisted_235 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {
    "font-style": "normal"
  }
}, "FIL", -1));
const _hoisted_236 = {
  key: 0
};
const _hoisted_237 = {
  class: "fs-12",
  style: {
    "opacity": ".6"
  }
};
const _hoisted_238 = {
  class: "computer-fil-footer"
};
const _hoisted_239 = {
  style: {
    "font-weight": "700"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_CaretBottom = _resolveComponent("CaretBottom");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold");
  const _component_Tools = _resolveComponent("Tools");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_ScrollNumber = _resolveComponent("ScrollNumber");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_Upload = _resolveComponent("Upload");
  const _component_Download = _resolveComponent("Download");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_select = _resolveComponent("el-select");
  const _component_SwitchButton = _resolveComponent("SwitchButton");
  const _component_RadioBtn = _resolveComponent("RadioBtn");
  const _component_BrowserWalletImg = _resolveComponent("BrowserWalletImg");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_EditPen = _resolveComponent("EditPen");
  const _component_Select = _resolveComponent("Select");
  const _component_Bottom = _resolveComponent("Bottom");
  const _component_Top = _resolveComponent("Top");
  const _component_CircleClose = _resolveComponent("CircleClose");
  const _component_transfer = _resolveComponent("transfer");
  const _component_el_drawer = _resolveComponent("el-drawer");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("nav", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _ctx.$store.state.evn === 'test' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_popover, {
    placement: "top-start",
    width: 200,
    trigger: "click"
  }, {
    reference: _withCtx(() => [_hoisted_7]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('common.The app is running in testnet mode')), 1), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
      color: "#E3E3E3",
      onClick: $options.disableTestnet
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('common.Disable testnet')), 1)]),
      _: 1
    }, 8, ["onClick"])])])]),
    _: 1
  })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_popover, {
    ref: "menuRef",
    placement: "bottom",
    width: "120",
    onShow: $options.showMenu,
    onHide: $options.hideMenu,
    trigger: "click"
  }, {
    reference: _withCtx(() => [_createElementVNode("button", {
      class: _normalizeClass(["navbar-toggler rounded-0 p-0 mr-3", $data.isShowMenu ? 'is-show-menu' : '']),
      type: "button",
      "data-toggle": "collapse",
      style: {
        "background-color": "#5fe3bd",
        "border": "none",
        "border-radius": "10px!important"
      },
      "aria-controls": "navlinks",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }, _hoisted_18, 2)]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menus, (menu, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "d-flex",
        key: index,
        onClick: $event => $options.checkMenu(menu)
      }, [menu.more !== true ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["cursor-pointer mb-2", $options.headerSimpleActivityClass(menu.path)])
      }, [_createTextVNode(_toDisplayString(menu.label) + " ", 1), menu.isNew ? (_openBlock(), _createElementBlock("img", _hoisted_16)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 8, _hoisted_15);
    }), 128))])]),
    _: 1
  }, 8, ["onShow", "onHide"]), _createElementVNode("div", _hoisted_19, [_createElementVNode("ul", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.menus, (menu, index) => {
    return _openBlock(), _createElementBlock(_Fragment, null, [menu.phone !== true ? (_openBlock(), _createElementBlock("li", {
      class: "nav-item",
      key: index,
      onClick: $event => $options.checkMenu(menu)
    }, [menu.more !== true ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["cursor-pointer position-relative", $options.headerActivityClass(menu)])
    }, [_createElementVNode("span", null, _toDisplayString(menu.label), 1), menu.isNew ? (_openBlock(), _createElementBlock("img", _hoisted_22)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), menu.more === true ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_dropdown, null, {
      dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.child, (childMenu, index2) => {
          return _openBlock(), _createBlock(_component_el_dropdown_item, {
            onClick: $event => $options.checkMenu(childMenu),
            key: index2
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              style: _normalizeStyle([{
                "width": "70px"
              }, $options._headerActivityClass2(childMenu.path)])
            }, _toDisplayString(childMenu.label), 5)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))]),
        _: 2
      }, 1024)]),
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass($options.headerActivityClass(menu))
      }, [_createElementVNode("span", _hoisted_24, [_createElementVNode("span", null, _toDisplayString(menu.label), 1), _createElementVNode("span", null, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      })])])], 2)]),
      _: 2
    }, 1024)])) : _createCommentVNode("", true)], 8, _hoisted_21)) : _createCommentVNode("", true)], 64);
  }), 256))])]), !$options.isConnected ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "connect-wallet-head-btn",
    onMouseenter: _cache[0] || (_cache[0] = (...args) => $options.handleEnter && $options.handleEnter(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.handleLeave && $options.handleLeave(...args)),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, [_createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('common.Connect Wallet')), 1), _createElementVNode("div", {
    class: _normalizeClass(["d-inline-flex justify-content-center align-items-center align-content-center", $options.connectWalletHover]),
    style: {
      "transition": "0.2s ease-out"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
    _: 1
  })], 2)], 32)) : _createCommentVNode("", true), $options.isConnected ? (_openBlock(), _createBlock(_component_el_popover, {
    key: 1,
    placement: "bottom-end",
    ref: "wallectPopoverRef",
    "popper-class": "header-div",
    "popper-style": {
      borderRadius: '15px'
    },
    offset: 10,
    onShow: _cache[18] || (_cache[18] = $event => {
      $data.isF4Copy = false;
      $data.isCopy = false;
      $data.isF1Copy = false;
    }),
    onHide: _cache[19] || (_cache[19] = $event => $data.innerDialog = 'none'),
    trigger: "click"
  }, {
    reference: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
      src: `data:image/svg+xml;base64,${$data.identiconImgBase64}`,
      style: {
        "width": "40px",
        "height": "40px",
        "border-radius": "44px"
      },
      alt: ""
    }, null, 8, _hoisted_28)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("img", {
      src: `data:image/svg+xml;base64,${$data.identiconImgBase64}`,
      style: _normalizeStyle([{
        "width": "25px",
        "border-radius": "15px"
      }, {
        opacity: $data.ledgerDeviceIsDisconnected && $data.connectType === 'Ledger' ? 0.3 : 1
      }]),
      alt: ""
    }, null, 12, _hoisted_31), $data.ledgerDeviceIsDisconnected && $data.connectType === 'Ledger' ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34)) : _createCommentVNode("", true)]), $options.isEmpty($options.fnsName) ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString($options.f1Address !== '' ? $options.simpleValue($options.f1Address, 6, 6) : $options.simpleValue($options.address, 6, 6)), 1)) : _createCommentVNode("", true), !$options.isEmpty($options.fnsName) ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString($options.fnsName), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_37, [_createVNode(_component_el_icon, {
      size: 20
    }, {
      default: _withCtx(() => [_createVNode(_component_Tools)]),
      _: 1
    })])])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('common.Wallet')), 1)]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("img", {
      src: `data:image/svg+xml;base64,${$data.identiconImgBase64}`,
      style: {
        "width": "40px",
        "border-radius": "50px"
      },
      alt: ""
    }, null, 8, _hoisted_43)]), _createElementVNode("div", _hoisted_44, [_createElementVNode("div", null, [$options.f1Address !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createElementVNode("div", null, [_hoisted_46, _createTextVNode(" " + _toDisplayString($options.simpleValue($options.f1Address, 6, 6)), 1)]), !$data.isF1Copy ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "account-info-copy cursor-pointer Copy copy-text",
      style: {
        "color": "#00CE92"
      },
      onClick: _cache[3] || (_cache[3] = (...args) => $options.copyF1Address && $options.copyF1Address(...args))
    }, _toDisplayString(_ctx.$t('common.copy')), 1)) : _createCommentVNode("", true), $data.isF1Copy ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.$t('common.copied')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $options.f1Address !== '' && $options.f0Address !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_hoisted_50, _createTextVNode(" " + _toDisplayString($options.f0Address), 1)])])) : _createCommentVNode("", true), $options.f1Address === '' ? (_openBlock(), _createElementBlock("div", _hoisted_51, [$options.isEmpty($options.fnsName) ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_hoisted_53, _createTextVNode(" " + _toDisplayString($options.simpleValue($options.address, 6, 6)), 1)])) : _createCommentVNode("", true), !$options.isEmpty($options.fnsName) ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_hoisted_55, _createTextVNode(" " + _toDisplayString($options.simpleValue($options.address, 6, 6)) + " ", 1), _createElementVNode("span", _hoisted_56, "(" + _toDisplayString($options.fnsName) + ")", 1)])) : _createCommentVNode("", true), !$options.isEmpty($options.fnsName) ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_hoisted_58, _createTextVNode(" " + _toDisplayString($options.simpleValue($options.address, 6, 6)) + " ", 1), _createElementVNode("span", _hoisted_59, "(" + _toDisplayString($options.fnsName) + ")", 1)])) : _createCommentVNode("", true), !$data.isCopy ? (_openBlock(), _createElementBlock("div", {
      key: 3,
      class: "account-info-copy cursor-pointer fs-12 copy-text",
      style: {
        "color": "#00CE92"
      },
      onClick: _cache[4] || (_cache[4] = (...args) => $options.copyAddress && $options.copyAddress(...args))
    }, _toDisplayString(_ctx.$t('common.copy')), 1)) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.$t('common.copied')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $options.f1Address === '' ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("div", null, [_hoisted_62, _createTextVNode(" " + _toDisplayString($options.simpleValue($options.f4Address, 6, 6)), 1)]), !$data.isF4Copy ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "account-info-copy cursor-pointer fs-12 copy-text",
      style: {
        "color": "#00CE92"
      },
      onClick: _cache[5] || (_cache[5] = (...args) => $options.copyF4Address && $options.copyF4Address(...args))
    }, _toDisplayString(_ctx.$t('common.copy')), 1)) : _createCommentVNode("", true), $data.isF4Copy ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.$t('common.copied')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_hoisted_68, _createElementVNode("div", _hoisted_69, [_hoisted_70, _createElementVNode("div", _hoisted_71, [_createVNode(_component_i_skeleton, {
      loading: $options.balanceLoading && !$options.timingFlag
    }, {
      template: _withCtx(() => [_createElementVNode("span", _hoisted_72, [_createVNode(_component_el_skeleton_item, {
        variant: "p",
        style: {
          "width": "100px",
          "opacity": ".6",
          "transform": "translateY(3px)"
        }
      })])]),
      default: _withCtx(() => [_createElementVNode("span", _hoisted_73, [_createVNode(_component_ScrollNumber, {
        customSignStyle: {
          margin: '0 -3.6px !important'
        },
        style: {
          "height": "18px",
          "line-height": "17px"
        },
        unitStyle: {
          margin: '0 0 0 2px'
        },
        customStyle: {
          margin: '0'
        },
        color: "",
        unit: "FIL",
        number: $options.formatWalletFilPrice($options.balance, 4, false, false, false),
        h: 13
      }, null, 8, ["customSignStyle", "number"])])]),
      _: 1
    }, 8, ["loading"])])])]), _createElementVNode("div", null, [_createVNode(_component_i_skeleton, {
      loading: $options.balanceLoading && !$options.timingFlag
    }, {
      template: _withCtx(() => [_createElementVNode("span", _hoisted_74, [_createVNode(_component_el_skeleton_item, {
        variant: "p",
        style: {
          "width": "100px",
          "opacity": ".6"
        }
      })])]),
      default: _withCtx(() => [_createElementVNode("span", _hoisted_75, _toDisplayString($options.toUsd($options.balance)) + " USD", 1)]),
      _: 1
    }, 8, ["loading"])])])]), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_hoisted_78, _createElementVNode("div", _hoisted_79, [_createElementVNode("div", _hoisted_80, [_hoisted_81, _createElementVNode("div", null, [_createVNode(_component_i_skeleton, {
      loading: $options.stFilBalanceLoading && !$options.timingFlag
    }, {
      template: _withCtx(() => [_createElementVNode("span", _hoisted_82, [_createVNode(_component_el_skeleton_item, {
        variant: "p",
        style: {
          "width": "100px",
          "opacity": ".6"
        }
      })])]),
      default: _withCtx(() => [_createElementVNode("span", _hoisted_83, _toDisplayString($options.toUsd($options.stFilBalance)) + " USD", 1)]),
      _: 1
    }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_84, [_createVNode(_component_i_skeleton, {
      loading: $options.stFilBalanceLoading && !$options.timingFlag
    }, {
      template: _withCtx(() => [_createElementVNode("span", _hoisted_85, [_createVNode(_component_el_skeleton_item, {
        variant: "p",
        style: {
          "width": "100px",
          "opacity": ".6",
          "transform": "translateY(3px)"
        }
      })])]),
      default: _withCtx(() => [_createElementVNode("span", _hoisted_86, [_createVNode(_component_ScrollNumber, {
        customSignStyle: {
          margin: '0 -3.6px !important'
        },
        style: {
          "height": "18px",
          "line-height": "17px"
        },
        unitStyle: {
          margin: '0 0 0 2px'
        },
        customStyle: {
          margin: '0'
        },
        color: "",
        unit: "stFIL",
        number: $options.formatWalletFilPrice($options.stFilBalance, 4, false, false, false),
        h: 13
      }, null, 8, ["customSignStyle", "number"])])]),
      _: 1
    }, 8, ["loading"])])])])]), _createElementVNode("div", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_hoisted_89, _createElementVNode("div", _hoisted_90, [_hoisted_91, _createElementVNode("div", _hoisted_92, [_createVNode(_component_i_skeleton, {
      loading: $options.wstFilBalanceLoading && !$options.timingFlag
    }, {
      template: _withCtx(() => [_createElementVNode("span", _hoisted_93, [_createVNode(_component_el_skeleton_item, {
        variant: "p",
        style: {
          "width": "100px",
          "opacity": ".6",
          "transform": "translateY(3px)"
        }
      })])]),
      default: _withCtx(() => [_createElementVNode("span", _hoisted_94, [_createVNode(_component_ScrollNumber, {
        customSignStyle: {
          margin: '0 -3.6px !important'
        },
        style: {
          "height": "18px",
          "line-height": "17px"
        },
        unitStyle: {
          margin: '0 0 0 2px'
        },
        customStyle: {
          margin: '0'
        },
        color: "",
        unit: "wstFIL",
        number: $options.formatWalletFilPrice($options.wstFilBalance, 4, false, false, false),
        h: 13
      }, null, 8, ["customSignStyle", "number"])])]),
      _: 1
    }, 8, ["loading"])]), _hoisted_95, _createElementVNode("div", _hoisted_96, [_createElementVNode("div", _hoisted_97, [_createElementVNode("div", _hoisted_98, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.$t('common.interest')), 1)])])]), _createElementVNode("div", null, [_createVNode(_component_i_skeleton, {
      loading: $options.stFilInterestLoading && !$options.timingFlag
    }, {
      template: _withCtx(() => [_createElementVNode("span", _hoisted_100, [_createVNode(_component_el_skeleton_item, {
        variant: "p",
        style: {
          "width": "100px",
          "opacity": ".6"
        }
      })])]),
      default: _withCtx(() => [_createElementVNode("span", _hoisted_101, [_createVNode(_component_ScrollNumber, {
        customSignStyle: {
          margin: '0 -3.6px !important'
        },
        style: {
          "height": "17px",
          "line-height": "16px"
        },
        unitStyle: {
          margin: '0 0 0 2px'
        },
        customStyle: {
          margin: '0'
        },
        color: "",
        unit: "FIL",
        number: $options.formatWalletFilPrice($options.stFilInterest, 4, false, true, false),
        h: 12
      }, null, 8, ["customSignStyle", "number"])])]),
      _: 1
    }, 8, ["loading"])])])])])]), _createElementVNode("div", _hoisted_102, [_createElementVNode("div", {
      class: "d-flex flex-column justify-content-center align-items-center cursor-pointer icon-hover",
      onClick: _cache[6] || (_cache[6] = (...args) => $options.transfer && $options.transfer(...args))
    }, [_createElementVNode("div", _hoisted_103, [_createVNode(_component_el_icon, {
      size: "20",
      color: "#ffffff"
    }, {
      default: _withCtx(() => [_createVNode(_component_Upload)]),
      _: 1
    })]), _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.$t('transfer.send')), 1)]), $data.receiveValue ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "d-flex flex-column justify-content-center align-items-center ml-4 cursor-pointer icon-hover",
      onClick: _cache[7] || (_cache[7] = (...args) => $options.receiveAddress && $options.receiveAddress(...args))
    }, [_createElementVNode("div", _hoisted_105, [_createVNode(_component_el_icon, {
      size: "20",
      color: "#ffffff"
    }, {
      default: _withCtx(() => [_createVNode(_component_Download)]),
      _: 1
    })]), _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.$t('transfer.receive')), 1)])) : _createCommentVNode("", true)])]), $data.connectType === 'Ledger' ? (_openBlock(), _createElementBlock("div", _hoisted_107, [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.$t('ledgerSp.accounts')), 1), _createElementVNode("div", _hoisted_110, [_createVNode(_component_el_select, {
      teleported: false,
      modelValue: $options.f1Address,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $options.f1Address = $event),
      onChange: $options.changeLedgerAccount,
      placeholder: "Select",
      "popper-class": "language-select-item",
      onVisibleChange: $options.visibleLedgerAccount
    }, {
      footer: _withCtx(() => [!$data.isAddLedgerAccount ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        text: "",
        bg: "",
        size: "small",
        onClick: _withModifiers($options.addLedgerAccount, ["stop"])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.add derivation path')), 1)]),
        _: 1
      }, 8, ["onClick"])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.$t('common.Please enter a derivation path')), 1), _createVNode(_component_el_input, {
        modelValue: $data.addLedgerAddress,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.addLedgerAddress = $event),
        class: _normalizeClass(["option-input", $data.addLedgerAddressErrTip !== '' ? 'option-input-err' : '']),
        onInput: _cache[9] || (_cache[9] = $event => $data.addLedgerAddressErrTip = ''),
        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
        size: "small",
        disabled: $data.addLedgerAddressLoading
      }, null, 8, ["modelValue", "class", "disabled"]), $data.addLedgerAddressErrTip !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_112, _toDisplayString($data.addLedgerAddressErrTip), 1)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        loading: $data.addLedgerAddressLoading,
        onClick: _withModifiers($options.onConfirmAddLedgerAccount, ["stop"])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Confirm')), 1)]),
        _: 1
      }, 8, ["loading", "onClick"]), _createVNode(_component_el_button, {
        size: "small",
        loading: $data.addLedgerAddressLoading,
        onClick: _withModifiers($options.clearAddLedgerAccount, ["stop"])
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('change.cancel')), 1)]),
        _: 1
      }, 8, ["loading", "onClick"])], 64))]),
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.accountListOption, item => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onChange", "onVisibleChange"])])])])) : _createCommentVNode("", true), _hoisted_113, _createElementVNode("div", _hoisted_114, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_SwitchButton)]),
      _: 1
    }), _createElementVNode("div", {
      class: "ml-2",
      onClick: _cache[12] || (_cache[12] = (...args) => $options.disconnect && $options.disconnect(...args))
    }, _toDisplayString(_ctx.$t('common.Disconnect Wallet')), 1)])], 512), [[_vShow, $data.innerDialog === 'none']]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_115, [_createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$t('transfer.receive')), 1)]), $data.receiveOptions.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_117, [_createVNode(_component_RadioBtn, {
      aRow: true,
      "tab-arr": $data.receiveOptions,
      modelValue: $data.receiveValue,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.receiveValue = $event)
    }, null, 8, ["tab-arr", "modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_118, [_createElementVNode("div", _hoisted_119, null, 512)]), _createElementVNode("div", _hoisted_120, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('transfer.Scan the address to receive payment')), 1), _createElementVNode("div", _hoisted_121, [$data.receiveValue === '0x' ? (_openBlock(), _createElementBlock("div", _hoisted_122, [_createElementVNode("div", _hoisted_123, _toDisplayString($options.simpleValue($options.address, 6, 6)), 1), !$data.isCopy ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "account-info-copy cursor-pointer fs-12 copy-text",
      style: {
        "color": "#00CE92"
      },
      onClick: _cache[14] || (_cache[14] = (...args) => $options.copyAddress && $options.copyAddress(...args))
    }, _toDisplayString(_ctx.$t('common.copy')), 1)) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("div", _hoisted_124, _toDisplayString(_ctx.$t('common.copied')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.receiveValue === 'f4' ? (_openBlock(), _createElementBlock("div", _hoisted_125, [_createElementVNode("div", _hoisted_126, _toDisplayString($options.simpleValue($options.f4Address, 6, 6)), 1), !$data.isF4Copy ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "account-info-copy cursor-pointer fs-12 copy-text",
      style: {
        "color": "#00CE92"
      },
      onClick: _cache[15] || (_cache[15] = (...args) => $options.copyF4Address && $options.copyF4Address(...args))
    }, _toDisplayString(_ctx.$t('common.copy')), 1)) : _createCommentVNode("", true), $data.isF4Copy ? (_openBlock(), _createElementBlock("div", _hoisted_127, _toDisplayString(_ctx.$t('common.copied')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.receiveValue === 'f1' ? (_openBlock(), _createElementBlock("div", _hoisted_128, [_createElementVNode("div", _hoisted_129, _toDisplayString($options.simpleValue($options.f1Address, 6, 6)), 1), !$data.isF1Copy ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "account-info-copy cursor-pointer Copy copy-text",
      style: {
        "color": "#00CE92"
      },
      onClick: _cache[16] || (_cache[16] = (...args) => $options.copyF1Address && $options.copyF1Address(...args))
    }, _toDisplayString(_ctx.$t('common.copy')), 1)) : _createCommentVNode("", true), $data.isF1Copy ? (_openBlock(), _createElementBlock("div", _hoisted_130, _toDisplayString(_ctx.$t('common.copied')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
      class: "mt-3",
      onClick: _cache[17] || (_cache[17] = (...args) => $options.showHome && $options.showHome(...args))
    }, [_createVNode(_component_el_button, {
      class: "btn btn-outline-clear w-100 i-button",
      style: {
        "padding-top": "20px !important",
        "padding-bottom": "20px !important"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.return')), 1)]),
      _: 1
    })])], 512), [[_vShow, $data.innerDialog === 'showAddress']])])]),
    _: 1
  }, 512)) : _createCommentVNode("", true)])]), _createVNode(_component_el_dialog, {
    modelValue: $data.connectWalletModelShow,
    "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => $data.connectWalletModelShow = $event),
    width: `${$data.dialogWidth}px`,
    "append-to-body": true
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_131, [_createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.$t('common.Connect a wallet')), 1)])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, [$data.connectWalletErrTip !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_135, [_createElementVNode("div", _hoisted_136, [_createElementVNode("span", null, _toDisplayString($data.connectWalletErrTip), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_137, [_createElementVNode("div", {
      style: _normalizeStyle({
        width: _ctx.screenWidth < 400 ? '80%' : '70%'
      })
    }, [$options.isShowWallet('okxApp') ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "d-flex justify-content-center w-100 cursor-pointer",
      style: _normalizeStyle({
        marginBottom: _ctx.screenWidth < 400 ? '1.25rem' : '1.5rem'
      }),
      onClick: _cache[20] || (_cache[20] = (...args) => $options.okxWalletConnect && $options.okxWalletConnect(...args)),
      onMouseenter: _cache[21] || (_cache[21] = $event => $options.handleEnterArr(9)),
      onMouseleave: _cache[22] || (_cache[22] = $event => $options.handleLeaveArr(9))
    }, [_createElementVNode("div", _hoisted_138, [!$data.loading.okxWalletLoading ? (_openBlock(), _createElementBlock("div", _hoisted_139, _hoisted_141)) : _createCommentVNode("", true), $data.loading.okxWalletLoading ? (_openBlock(), _createElementBlock("div", _hoisted_142, [_withDirectives(_createElementVNode("div", null, null, 512), [[_directive_loading, $data.loading.okxWalletLoading]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_143, [_createElementVNode("div", _hoisted_144, _toDisplayString($data.okxWalletInstall || $data.isMobile ? 'OKX Wallet' : 'Install OKX Wallet'), 1), _createElementVNode("div", {
      class: _normalizeClass(["d-inline-flex justify-content-center align-items-center align-content-center", $options.hoverClass(9)]),
      style: {
        "transition": "0.2s ease-out"
      }
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
      _: 1
    })], 2)]), _createElementVNode("div", _hoisted_145, [_ctx.$i18n.locale === 'zh' ? (_openBlock(), _createElementBlock("span", _hoisted_146, _hoisted_148)) : _createCommentVNode("", true), _ctx.$i18n.locale === 'en' ? (_openBlock(), _createElementBlock("span", _hoisted_149, _hoisted_151)) : _createCommentVNode("", true)])])], 36)) : _createCommentVNode("", true), $options.isShowBrowserWallet() ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      onClick: _cache[23] || (_cache[23] = (...args) => $options.browserWalletConnect && $options.browserWalletConnect(...args)),
      class: "d-flex justify-content-center w-100 cursor-pointer",
      style: _normalizeStyle({
        marginBottom: _ctx.screenWidth < 400 ? '1.25rem' : '1.5rem'
      }),
      onMouseenter: _cache[24] || (_cache[24] = $event => $options.handleEnterArr(8)),
      onMouseleave: _cache[25] || (_cache[25] = $event => $options.handleLeaveArr(8))
    }, [_createElementVNode("div", _hoisted_152, [!$data.loading.browserWalletLoading ? (_openBlock(), _createElementBlock("div", _hoisted_153, [_createVNode(_component_BrowserWalletImg)])) : _createCommentVNode("", true), $data.loading.browserWalletLoading ? (_openBlock(), _createElementBlock("div", _hoisted_154, [_withDirectives(_createElementVNode("div", null, null, 512), [[_directive_loading, $data.loading.browserWalletLoading]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_155, [_createElementVNode("div", _hoisted_156, _toDisplayString(_ctx.$t('common.Browser Wallet')), 1), _createElementVNode("div", {
      class: _normalizeClass(["d-inline-flex justify-content-center align-items-center align-content-center", $options.hoverClass(8)]),
      style: {
        "transition": "0.2s ease-out"
      }
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
      _: 1
    })], 2)])])], 36)) : _createCommentVNode("", true), $options.isShowWallet('metamask') ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: "d-flex justify-content-center w-100 cursor-pointer",
      style: _normalizeStyle({
        marginBottom: _ctx.screenWidth < 400 ? '1.25rem' : '1.5rem'
      }),
      onClick: _cache[26] || (_cache[26] = (...args) => $options.metaMaskConnect && $options.metaMaskConnect(...args)),
      onMouseenter: _cache[27] || (_cache[27] = $event => $options.handleEnterArr(0)),
      onMouseleave: _cache[28] || (_cache[28] = $event => $options.handleLeaveArr(0))
    }, [_createElementVNode("div", _hoisted_157, [!$data.loading.metamaskLoading ? (_openBlock(), _createElementBlock("div", _hoisted_158, _hoisted_160)) : _createCommentVNode("", true), $data.loading.metamaskLoading ? (_openBlock(), _createElementBlock("div", _hoisted_161, [_withDirectives(_createElementVNode("div", null, null, 512), [[_directive_loading, $data.loading.metamaskLoading]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_162, [_createElementVNode("div", _hoisted_163, _toDisplayString($data.metaMaskInstall || $data.isMobile ? 'MetaMask' : 'Install MetaMask'), 1), _createElementVNode("div", {
      class: _normalizeClass(["d-inline-flex justify-content-center align-items-center align-content-center", $options.hoverClass(0)]),
      style: {
        "transition": "0.2s ease-out"
      }
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
      _: 1
    })], 2)])])], 36)) : _createCommentVNode("", true), !$data.isMobile ? (_openBlock(), _createElementBlock("div", {
      key: 3,
      class: "d-flex justify-content-center w-100 cursor-pointer",
      style: _normalizeStyle({
        marginBottom: _ctx.screenWidth < 400 ? '1.25rem' : '1.5rem'
      }),
      onClick: _cache[29] || (_cache[29] = (...args) => $options.metaMaskFlaskConnect && $options.metaMaskFlaskConnect(...args)),
      onMouseenter: _cache[30] || (_cache[30] = $event => $options.handleEnterArr(6)),
      onMouseleave: _cache[31] || (_cache[31] = $event => $options.handleLeaveArr(6))
    }, [_createElementVNode("div", _hoisted_164, [!$data.loading.metaMaskFlaskLoading ? (_openBlock(), _createElementBlock("div", _hoisted_165, _hoisted_167)) : _createCommentVNode("", true), $data.loading.metaMaskFlaskLoading ? (_openBlock(), _createElementBlock("div", _hoisted_168, [_withDirectives(_createElementVNode("div", null, null, 512), [[_directive_loading, $data.loading.metaMaskFlaskLoading]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_169, [_createElementVNode("div", _hoisted_170, _toDisplayString($data.metaMaskFlaskInstall || $data.isMobile ? 'MetaMask Flask' : 'Install MetaMask Flask'), 1), _createElementVNode("div", {
      class: _normalizeClass(["d-inline-flex justify-content-center align-items-center align-content-center", $options.hoverClass(6)]),
      style: {
        "transition": "0.2s ease-out"
      }
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
      _: 1
    })], 2)])])], 36)) : _createCommentVNode("", true), !$data.isMobile ? (_openBlock(), _createElementBlock("div", {
      key: 4,
      class: "d-flex justify-content-center w-100 cursor-pointer",
      style: _normalizeStyle({
        marginBottom: _ctx.screenWidth < 400 ? '1.25rem' : '1.5rem'
      }),
      onClick: _cache[32] || (_cache[32] = (...args) => $options.ledgerFileCoinConnect && $options.ledgerFileCoinConnect(...args)),
      onMouseenter: _cache[33] || (_cache[33] = $event => $options.handleEnterArr(3)),
      onMouseleave: _cache[34] || (_cache[34] = $event => $options.handleLeaveArr(3))
    }, [_createElementVNode("div", _hoisted_171, [!$data.loading.ledgerLoading ? (_openBlock(), _createElementBlock("div", _hoisted_172, _hoisted_174)) : _createCommentVNode("", true), $data.loading.ledgerLoading ? (_openBlock(), _createElementBlock("div", _hoisted_175, [_withDirectives(_createElementVNode("div", null, null, 512), [[_directive_loading, $data.loading.ledgerLoading]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_176, [_hoisted_177, _createElementVNode("div", {
      class: _normalizeClass(["d-inline-flex justify-content-center align-items-center align-content-center", $options.hoverClass(3)]),
      style: {
        "transition": "0.2s ease-out"
      }
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
      _: 1
    })], 2)])])], 36)) : _createCommentVNode("", true), $data.isMobile && $options.isShowWallet('foxWallet') ? (_openBlock(), _createElementBlock("div", {
      key: 5,
      class: "d-flex justify-content-center w-100 cursor-pointer",
      style: _normalizeStyle({
        marginBottom: _ctx.screenWidth < 400 ? '1.25rem' : '1.5rem'
      }),
      onClick: _cache[35] || (_cache[35] = (...args) => $options.foxWalletConnect && $options.foxWalletConnect(...args)),
      onMouseenter: _cache[36] || (_cache[36] = $event => $options.handleEnterArr(1)),
      onMouseleave: _cache[37] || (_cache[37] = $event => $options.handleLeaveArr(1))
    }, [_createElementVNode("div", _hoisted_178, [!$data.loading.foxWalletLoading ? (_openBlock(), _createElementBlock("div", _hoisted_179, _hoisted_181)) : _createCommentVNode("", true), $data.loading.foxWalletLoading ? (_openBlock(), _createElementBlock("div", _hoisted_182, [_withDirectives(_createElementVNode("div", null, null, 512), [[_directive_loading, $data.loading.foxWalletLoading]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_183, [_hoisted_184, _createElementVNode("div", {
      class: _normalizeClass(["d-inline-flex justify-content-center align-items-center align-content-center", $options.hoverClass(1)]),
      style: {
        "transition": "0.2s ease-out"
      }
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
      _: 1
    })], 2)])])], 36)) : _createCommentVNode("", true), $options.env !== 'test' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 6
    }, [$data.isMobile && $options.isShowWallet('tokenPocket') ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "d-flex justify-content-center w-100 cursor-pointer",
      style: _normalizeStyle({
        marginBottom: _ctx.screenWidth < 400 ? '1.25rem' : '1.5rem'
      }),
      onClick: _cache[38] || (_cache[38] = (...args) => $options.tokenPocketConnect && $options.tokenPocketConnect(...args)),
      onMouseenter: _cache[39] || (_cache[39] = $event => $options.handleEnterArr(7)),
      onMouseleave: _cache[40] || (_cache[40] = $event => $options.handleLeaveArr(7))
    }, [_createElementVNode("div", _hoisted_185, [!$data.loading.tokenPocketLoading ? (_openBlock(), _createElementBlock("div", _hoisted_186, _hoisted_188)) : _createCommentVNode("", true), $data.loading.tokenPocketLoading ? (_openBlock(), _createElementBlock("div", _hoisted_189, [_withDirectives(_createElementVNode("div", null, null, 512), [[_directive_loading, $data.loading.tokenPocketLoading]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_190, [_hoisted_191, _createElementVNode("div", {
      class: _normalizeClass(["d-inline-flex justify-content-center align-items-center align-content-center", $options.hoverClass(7)]),
      style: {
        "transition": "0.2s ease-out"
      }
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
      _: 1
    })], 2)])])], 36)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "d-flex justify-content-center w-100 cursor-pointer",
      onClick: _cache[41] || (_cache[41] = (...args) => $options.WalletConnectConnect && $options.WalletConnectConnect(...args)),
      onMouseenter: _cache[42] || (_cache[42] = $event => $options.handleEnterArr(2)),
      onMouseleave: _cache[43] || (_cache[43] = $event => $options.handleLeaveArr(2))
    }, [_createElementVNode("div", _hoisted_192, [!$data.loading.walletConnectLoading ? (_openBlock(), _createElementBlock("div", _hoisted_193, _hoisted_195)) : _createCommentVNode("", true), $data.loading.walletConnectLoading ? (_openBlock(), _createElementBlock("div", _hoisted_196, [_withDirectives(_createElementVNode("div", null, null, 512), [[_directive_loading, $data.loading.walletConnectLoading]])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_197, [_hoisted_198, _createElementVNode("div", {
      class: _normalizeClass(["d-inline-flex justify-content-center align-items-center align-content-center", $options.hoverClass(2)]),
      style: {
        "transition": "0.2s ease-out"
      }
    }, [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_ArrowRightBold)]),
      _: 1
    })], 2)])])], 32)], 4)])])])]),
    _: 1
  }, 8, ["modelValue", "width"]), _createVNode(_component_el_dialog, {
    modelValue: $data.switchNetModelShow,
    "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => $data.switchNetModelShow = $event),
    "show-close": false,
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    width: "445px",
    top: "10%",
    "before-close": $options.closeSwitchNetDialog
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_199, [_hoisted_200, _createElementVNode("div", _hoisted_201, [_createElementVNode("div", _hoisted_202, _toDisplayString(_ctx.$t('common.networkTitle')), 1)]), _createElementVNode("div", _hoisted_203, [_createElementVNode("div", _hoisted_204, _toDisplayString(_ctx.$t('common.networkTip')), 1)]), _createElementVNode("div", _hoisted_205, [_createVNode(_component_el_button, {
      class: "btn btn-primary w-100 i-button",
      type: "primary",
      onClick: $options.switchNetworkFun
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.Switch network')), 1)]),
      _: 1
    }, 8, ["onClick"])])])]),
    _: 1
  }, 8, ["modelValue", "before-close"])]), $data.showLanguageTips ? (_openBlock(), _createElementBlock("div", _hoisted_206, [_createElementVNode("div", _hoisted_207, [_hoisted_208, _hoisted_209, _createElementVNode("div", _hoisted_210, [_createElementVNode("div", {
    class: "language-tips-content-btn-allow",
    id: "language-tips-btn-allow",
    onClick: _cache[46] || (_cache[46] = (...args) => $options.allowChangeLanguage && $options.allowChangeLanguage(...args))
  }, " 继续 "), _createElementVNode("div", {
    class: "language-tips-content-btn-decline",
    id: "language-tips-btn-decline",
    onClick: _cache[47] || (_cache[47] = (...args) => $options.closeChangeLanguage && $options.closeChangeLanguage(...args))
  }, " Ignore ")])])])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
    modelValue: $data.apyComputerShow,
    "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => $data.apyComputerShow = $event),
    class: "apyComputerClass",
    width: "375px",
    top: "10%",
    "before-close": $options.closeApyComputerShowDialog
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_211, [_createElementVNode("div", _hoisted_212, _toDisplayString(_ctx.$t('computer.ROI Calculator')), 1)])]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_238, [_createElementVNode("span", {
      class: "fw-bold cursor-pointer fsi-18",
      onClick: _cache[59] || (_cache[59] = (...args) => $options.gotoStake && $options.gotoStake(...args))
    }, _toDisplayString(_ctx.$t('computer.STAKEFil')), 1)])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_213, [_createElementVNode("div", _hoisted_214, [_createElementVNode("div", _hoisted_215, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('computer.FIL STATKED')), 1), _createElementVNode("div", _hoisted_216, [_hoisted_217, !$data.editApiMode ? (_openBlock(), _createElementBlock("div", _hoisted_218, _toDisplayString($data.computerAPYValue) + "%", 1)) : _createCommentVNode("", true), $data.editApiMode ? (_openBlock(), _createElementBlock("div", _hoisted_219, [_createVNode(_component_el_input, {
      modelValue: $data.computerAPYValue,
      "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => $data.computerAPYValue = $event),
      placeholder: "0.00",
      inputmode: "decimal",
      pattern: "^[0-9]+[.,]?[0-9]*$",
      onInput: $options.computerAPYtValueInput,
      ref: "computerFilResultValueRef"
    }, {
      suffix: _withCtx(() => [_hoisted_220]),
      _: 1
    }, 8, ["modelValue", "onInput"])])) : _createCommentVNode("", true), !$data.editApiMode ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: "cursor-pointer",
      style: {
        "transform": "translateY(2px)"
      },
      onClick: _cache[49] || (_cache[49] = (...args) => $options.changeAPYMode && $options.changeAPYMode(...args))
    }, [_createVNode(_component_el_icon, {
      size: "16"
    }, {
      default: _withCtx(() => [_createVNode(_component_EditPen, {
        color: "rgb(96, 98, 102)"
      })]),
      _: 1
    })])) : _createCommentVNode("", true), $data.editApiMode ? (_openBlock(), _createElementBlock("div", {
      key: 3,
      class: "cursor-pointer ml-2",
      style: {
        "transform": "translateY(2px)"
      },
      onClick: _cache[50] || (_cache[50] = (...args) => $options.cancelChangeAPYMode && $options.cancelChangeAPYMode(...args))
    }, [_createVNode(_component_el_icon, {
      size: "16"
    }, {
      default: _withCtx(() => [_createVNode(_component_Select, {
        color: "#6752F0"
      })]),
      _: 1
    })])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_221, [_createVNode(_component_el_input, {
      modelValue: $data.computerFilValue,
      "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => $data.computerFilValue = $event),
      onFocus: $options.cancelComputerResult,
      size: "large",
      placeholder: "0.00",
      onInput: $options.computerFilValueInput
    }, {
      suffix: _withCtx(() => [_hoisted_222]),
      _: 1
    }, 8, ["modelValue", "onFocus", "onInput"])]), _createElementVNode("div", _hoisted_223, [_createElementVNode("div", {
      class: "computerFilInputBalance mr-2 cursor-pointer",
      onClick: _cache[52] || (_cache[52] = $event => $options.setComputerFilValue(100))
    }, "100FIL"), _createElementVNode("div", {
      class: "computerFilInputBalance mr-2 cursor-pointer",
      onClick: _cache[53] || (_cache[53] = $event => $options.setComputerFilValue(1000))
    }, "1000FIL"), _createElementVNode("div", {
      class: _normalizeClass(["computerFilInputBalance mr-2 cursor-pointer", $options.isConnected ? '' : 'computerFilInputBalanceDis']),
      onClick: _cache[54] || (_cache[54] = $event => $options.setBalanceComputerFilValue())
    }, _toDisplayString(_ctx.$t('computer.MyBalance')), 3)]), _createElementVNode("div", _hoisted_224, _toDisplayString(_ctx.$t('computer.STAKED FOR')), 1), _createElementVNode("div", _hoisted_225, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.computerFilDays, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["computer-fil-day-item", $data.computerFilDayIndex === index ? 'computer-fil-day-item-active' : '']),
        onClick: $event => $options.selectDay(index),
        key: index
      }, _toDisplayString(item.label), 11, _hoisted_226);
    }), 128))]), _createElementVNode("div", _hoisted_227, [_createElementVNode("div", {
      class: _normalizeClass($data.computeIconAnimatio ? 'compute-icon' : '')
    }, [!$data.editComputer ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0,
      size: $data.bottomSize
    }, {
      default: _withCtx(() => [_createVNode(_component_Bottom)]),
      _: 1
    }, 8, ["size"])) : _createCommentVNode("", true), $data.editComputer ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 1,
      size: $data.bottomSize
    }, {
      default: _withCtx(() => [_createVNode(_component_Top)]),
      _: 1
    }, 8, ["size"])) : _createCommentVNode("", true)], 2)]), _createElementVNode("div", _hoisted_228, [_createElementVNode("div", _hoisted_229, [_createElementVNode("div", _hoisted_230, [_createElementVNode("div", _hoisted_231, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('computer.ROI AT CURRENT RATES')), 1)]), _createElementVNode("div", _hoisted_232, [!$data.editComputer ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: _cache[55] || (_cache[55] = (...args) => $options.editComputerResult && $options.editComputerResult(...args))
    }, [_createElementVNode("span", _hoisted_233, _toDisplayString($data.computerFilResultValue) + " FIL", 1)])) : _createCommentVNode("", true), $data.editComputer ? (_openBlock(), _createElementBlock("div", _hoisted_234, [_createVNode(_component_el_input, {
      modelValue: $data.computerFilResultValue,
      "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => $data.computerFilResultValue = $event),
      placeholder: "0.00",
      inputmode: "decimal",
      pattern: "^[0-9]+[.,]?[0-9]*$",
      onInput: $options.computerFilResultValueInput,
      ref: "computerFilResultValueRef"
    }, {
      suffix: _withCtx(() => [_hoisted_235]),
      _: 1
    }, 8, ["modelValue", "onInput"])])) : _createCommentVNode("", true), !$data.editComputer ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: "cursor-pointer",
      onClick: _cache[57] || (_cache[57] = (...args) => $options.editComputerResult && $options.editComputerResult(...args))
    }, [_createVNode(_component_el_icon, {
      size: "22"
    }, {
      default: _withCtx(() => [_createVNode(_component_EditPen, {
        color: "#6752F0"
      })]),
      _: 1
    })])) : _createCommentVNode("", true), $data.editComputer ? (_openBlock(), _createElementBlock("div", {
      key: 3,
      class: "cursor-pointer",
      onClick: _cache[58] || (_cache[58] = (...args) => $options.cancelComputerResult && $options.cancelComputerResult(...args))
    }, [_createVNode(_component_el_icon, {
      size: "20"
    }, {
      default: _withCtx(() => [_createVNode(_component_Select, {
        color: "#6752F0"
      })]),
      _: 1
    })])) : _createCommentVNode("", true)]), $options.filPrice !== '0.00' ? (_openBlock(), _createElementBlock("div", _hoisted_236, [_createElementVNode("span", _hoisted_237, "~ $" + _toDisplayString($data.computerFilResultValueUsd), 1)])) : _createCommentVNode("", true)])])])])])]),
    _: 1
  }, 8, ["modelValue", "before-close"]), _createVNode(_component_el_drawer, {
    modelValue: $data.transferDrawerFlag,
    "onUpdate:modelValue": _cache[62] || (_cache[62] = $event => $data.transferDrawerFlag = $event),
    size: $data.transferDrawerWidth,
    class: "transfer-drawer-class",
    "show-close": false,
    "before-close": $options.transferDrawerClose
  }, {
    header: _withCtx(() => [_createElementVNode("h4", _hoisted_239, _toDisplayString(_ctx.$t('transfer.transfer')), 1), _createElementVNode("div", {
      onClick: _cache[61] || (_cache[61] = (...args) => $options.transferDrawerClose && $options.transferDrawerClose(...args)),
      class: "icon-hover cursor-pointer"
    }, [_createVNode(_component_el_icon, {
      size: "30"
    }, {
      default: _withCtx(() => [_createVNode(_component_CircleClose)]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_transfer)]),
    _: 1
  }, 8, ["modelValue", "size", "before-close"])]);
}